import { useState, useCallback } from 'react';

import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, GoBackButton, ConfirmModal } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IPackage } from '~/models/Common';
import ProfessionalService from '~/services/Professional';

import * as S from './styles';

interface IPackageDetailRouterState {
  packageData: IPackage;
}

interface IPackageDetailParams {
  packageId: string;
  id: string;
}

const packageTraduction: { [packageName: string]: string } = {
  monthly: 'Mensal',
  quarterly: 'Trimestral',
  semiannual: 'Semestral',
  annual: 'Anual',
};

const PackageDetail = () => {
  const { setLoading } = useLoading();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const { id, packageId } = useParams<IPackageDetailParams>();
  const router = useHistory();
  const packageData = useLocation<IPackageDetailRouterState>().state
    ?.packageData;

  if (!packageData) {
    router.goBack();
  }

  const handleOpenConfirmModal = useCallback(() => {
    setConfirmDeleteModal(true);
  }, []);

  const handleDeletePackage = useCallback(async () => {
    try {
      setLoading(true);

      await ProfessionalService.deleteUserPackage(packageId);
      toast.success('Pacote excluído com sucesso!');

      setLoading(false);

      router.goBack();
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao solicitar a requisição!');
    }
  }, []);

  const handleNavigateToEditPackage = useCallback(() => {
    router.push(`/users/details/${id}/packages/edit/${packageId}`, {
      packageData,
    });
  }, [id, packageData, packageId, router]);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Detalhes do Pacote</S.Title>
        </S.Header>
        <S.InfosContainer>
          <S.InfosItem>
            <S.InfosItemTitle>Nome</S.InfosItemTitle>
            <S.InfosItemValue>{packageData.name}</S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Valor</S.InfosItemTitle>
            <S.InfosItemValue>{packageData.value}</S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>N° de programas de treino</S.InfosItemTitle>
            <S.InfosItemValue>
              {packageData.number_of_training_programs}
            </S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Fidelização</S.InfosItemTitle>
            <S.InfosItemValue>
              {packageTraduction[packageData.lealtad]}
            </S.InfosItemValue>
          </S.InfosItem>
          <S.InfosItem>
            <S.InfosItemTitle>Status</S.InfosItemTitle>
            <S.InfosItemValue>
              {packageData.status === 'active' ? 'Ativo' : 'Inativo'}
            </S.InfosItemValue>
          </S.InfosItem>
        </S.InfosContainer>
        {/* <S.Footer>
          <Button
            variant="black"
            textContent="Editar"
            onClick={handleNavigateToEditPackage}
            size="small"
            extraStyles={{
              maxWidth: '20rem',
              maxHeight: '3.5rem',
            }}
          />
          <Button
            variant="red"
            textContent="Excluir"
            onClick={handleOpenConfirmModal}
            size="small"
            extraStyles={{
              maxWidth: '20rem',
              maxHeight: '3.5rem',
            }}
          />
        </S.Footer> */}
      </S.Container>

      <ConfirmModal
        modalIsVisible={confirmDeleteModal}
        setModalIsVisible={setConfirmDeleteModal}
        handleSubmit={handleDeletePackage}
        textContent="Tem certeza de que deseja excluir esse pacote?"
        title="Deletar pacote"
      />
    </>
  );
};

export default PackageDetail;
